var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A4D98",
    fillRule: "evenodd",
    d: "M9 13.4a6.006 6.006 0 00-6 6c0 .22.18.4.4.4h11.2a.4.4 0 00.4-.4 6.006 6.006 0 00-6-6zm0-8A3.8 3.8 0 119 13a3.8 3.8 0 010-7.6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3299FE",
    fillRule: "evenodd",
    d: "M13.665 11.002L13.8 11a6.006 6.006 0 016 6 .4.4 0 01-.4.4h-3.483a7.225 7.225 0 00-3.65-4.415 5.01 5.01 0 001.399-1.983zm.136-.402a5.002 5.002 0 00-3.04-6.081A3.8 3.8 0 1113.8 10.6zm-3.605-5.008a3.802 3.802 0 012.408 4.816 3.802 3.802 0 00-2.408-4.816zm2.03 5.618zM9.002 13.4c.719.001 1.409.128 2.048.361a6.009 6.009 0 00-2.048-.361z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsActive);
export default __webpack_public_path__ + "static/media/clients-active.56ebde56cd2cf4dbbd3e8234a4a42ba8.svg";
export { ForwardRef as ReactComponent };